import { render } from "./ForestryExplorerTool.vue?vue&type=template&id=5972aafc&scoped=true"
import script from "./ForestryExplorerTool.vue?vue&type=script&lang=js"
export * from "./ForestryExplorerTool.vue?vue&type=script&lang=js"

import "./ForestryExplorerTool.vue?vue&type=style&index=0&id=5972aafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5972aafc"]])

export default __exports__